export const tileTemplate = {
    id: 'tile_wrapper',
    className: 'tile-element',
    component: 'div',
    children: [
        {
            id: 'tile_header',
            className: 'tile-element__header',
            component: 'div',
            children: [
                {
                    id: 'tile_header_left',
                    className: 'tile-element__header-left',
                    component: 'div',
                    children: [
                        {
                            component: 'TileFavorite',
                        },
                    ],
                },

                {
                    component: 'TileLock',
                },
                {
                    id: 'tile_header_right',
                    className: 'tile-element__header-right',
                    component: 'div',
                    children: [{ component: 'TileEdit' }, { component: 'TileInfo' }],
                },
            ],
        },
        {
            id: 'tile_body',
            component: 'div',
            className: 'tile-element__body',
            children: [
                {
                    id: 'tile_body_content',
                    component: 'div',
                    className: 'tile-element__body-content',
                    children: [
                        {
                            component: 'TileName',
                        },
                        {
                            component: 'ReportToolSection',
                        },
                    ],
                },
                {
                    id: 'tile_body_image',
                    component: 'div',
                    className: 'tile-element__body-image',
                    children: [
                        {
                            component: 'ThumbnailImage',
                        },
                    ],
                },
            ],
        },
    ],
};
export const listTemplate = {
    id: 'line_wrapper',
    className: 'tile-element',
    component: 'div',
    children: [
        {
            component: 'ThumbnailImage',
        },
        {
            component: 'TileName',
        },
        {
            component: 'ReportToolSectionLine',
        },
        {
            id: 'line_actions_wrapper',
            component: 'div',
            className: 'icons-holder tile-element__icons-holder',
            children: [{ component: 'TileInfo' }, { component: 'TileFavorite' }, { component: 'TileEdit' }],
        },
    ],
};
export const multiListTemplate = {
    id: 'line_wrapper',
    component: 'div',
    className: 'tile-element',
    children: [
        {
            component: 'TileName',
        },
        {
            component: 'div',
            className: 'icons-holder tile-element__icons-holder',
            children: [
                { component: 'TileEdit' },
                { component: 'TileFavorite' },
                { component: 'TileLock' },
                { component: 'TileInfo' },
            ],
        },
    ],
};
